import { pharmacyClient } from "@/connect";

export const getSlowMovingItems = async (page: number, pageSize: number) => {
  return await pharmacyClient.slowMovingItemsReport({
    pageNumber: page,
    pageSize: pageSize,
  });
};